// extracted by mini-css-extract-plugin
export default {"BoA-individual-pages":"TableOfContents_BoA-individual-pages__Hxpgs"};